import { App, View } from "@pimo/pimo-app-builder";
import { DragAndDropLayout } from "@pimo/pimo-components/src/lib/layouts/drag-and-drop-layout/drag-and-drop-layout";

import { TestAppState } from "../../app";
import { addCapabilitiesCards } from "./cards/capabilities";
import { addContractsCard } from "./cards/contracts";
import { addCriticalityCards } from "./cards/criticality";
import { addDistributionChannelCards } from "./cards/distribution-channels";
import { addLifeCycleCards } from "./cards/life-cycle";
import { addOverviewNumberCards } from "./cards/overview-numbers";
import { addProcessStepsCards } from "./cards/process-steps";
import { addRecordSourceCards } from "./cards/record-source";
import { addProjectTeamCard } from "./cards/team";
import { addTechnicalExposureCards } from "./cards/technical-exposure";
import { addTitleCards } from "./cards/title";

type ReportCard = (
  view: View<TestAppState, DragAndDropLayout>,
  app: App<TestAppState>
) => void;

/**
 * Every *static* card the report page is made of, **in the order they are
 * added**, up to (but not including) the tracking items table (#2222).
 *
 * The order is the point of this array: the drag-and-drop layout places
 * cards by the sequence in which they reach the view. Keeping it as data
 * rather than a run of calls inside the plugin is what lets a spec assert it
 * — see `report-plugin.structure.spec.ts`.
 *
 * The tracking items table is not in this list: at roughly 1,400 lines,
 * carrying the table's columns, cell renderers, and sort/filter/column-
 * configuration state, it needs its own focused follow-up rather than being
 * folded into this mechanical split. `ReportPlugin` still builds it directly
 * in `addComponentsToLayout`, right after these cards.
 *
 * Cards that never touch the app declare `(view)` alone; a narrower
 * parameter list is assignable to the wider type, so they need no unused
 * second parameter to sit in this array.
 */
export const REPORT_CARDS: ReportCard[] = [
  addTitleCards,
  addOverviewNumberCards,
  addCriticalityCards,
  addDistributionChannelCards,
  addRecordSourceCards,
  addProcessStepsCards,
  addCapabilitiesCards,
  addTechnicalExposureCards,
  addLifeCycleCards,
  addProjectTeamCard,
  addContractsCard,
];
